import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FAQItem from './FAQItem';
import './FAQSection.scss';

const FAQSection = () => {
    const [openItem, setOpenItem] = useState(null);
    const { t } = useTranslation();

    const faqData = [
        {
            id: 1,
            question: t('question_1'),
            answer: (
                <>
                    <p><strong>{t('sunday')}</strong></p>
                    <p>{t('service_english')}</p>
                    <p>{t('service_ukrainian')}</p>
                    <p>{t('service_evening')}</p>
                </>
            )
        },
        { id: 2, question: t('question_2'), answer: t('answer_2') },
        { id: 3, question: t('question_3'), answer: t('answer_3') },
        { id: 4, question: t('question_4'), answer: t('answer_4') },
        { id: 5, question: t('question_5'), answer: t('answer_5') },
        { id: 6, question: t('question_6'), answer: t('answer_6') },
        { id: 7, question: t('question_7'), answer: t('answer_7') },
        { id: 8, question: t('question_8'), answer: t('answer_8') }
    ];

    const toggleItem = (id) => {
        setOpenItem(openItem === id ? null : id);
    };

    return (
        <section className="faq-section">
            <div className="faq-section__container">
                <div className="faq-section__grid">
                    <div className="faq-section__left">
                        <div className="faq-section__content">
                            <h2 className="faq-section__title">{t('faq')}</h2>
                            <h3 className="faq-section__subtitle">{t('faq_subtitle')}</h3>
                            <div className="faq-section__block">
                                <p className="faq-section__description">
                                    {t('faq_description')}
                                </p>
                                <Link to="/about" className="button button--primary">
                                    {t('about_us_button')}
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="faq-section__right">
                        <div className="faq-section__list">
                            {faqData.map((item) => (
                                <FAQItem
                                    key={item.id}
                                    item={item}
                                    isOpen={openItem === item.id}
                                    onToggle={toggleItem}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
